class MochiInstallationVideo extends HTMLElement {
  connectedCallback() {
    if (this.abortController) return;
    this.dialog = this.querySelector('dialog');
    this.trigger = this.querySelector('[data-installation-open]');
    if (!this.dialog || !this.trigger) return;
    this.abortController = new AbortController();
    const { signal } = this.abortController;
    this.trigger.addEventListener('click', () => this.openVideo(), { signal });
    this.querySelector('[data-installation-close]')?.addEventListener('click', () => this.dialog.close(), { signal });
    this.dialog.addEventListener('close', () => this.finishClose(), { signal });
    this.dialog.addEventListener('click', (event) => {
      if (event.target !== this.dialog) return;
      const rect = this.dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
    }, { signal });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.querySelector('video')?.pause();
    }, { signal });
    this.querySelector('video')?.addEventListener('error', () => this.showError(), { signal });
  }

  openVideo() {
    if (this.dialog.open) return;
    let video = this.querySelector('video');
    if (!video) {
      const template = this.querySelector('[data-installation-template]');
      const media = this.querySelector('[data-installation-media]');
      if (!template || !media) return;
      media.append(template.content.cloneNode(true));
      video = media.querySelector('video');
      video?.addEventListener('error', () => this.showError(), { signal: this.abortController.signal });
    }
    this.dialog.showModal();
    this.trigger.setAttribute('aria-expanded', 'true');
    this.ownsScrollLock = true;
    document.documentElement.classList.add('mochi-installation-open');
    const error = this.querySelector('[data-installation-error]');
    if (error) error.hidden = true;
    if (video?.error) video.load();
    // Muted inline playback starts from the customer's tap; native controls allow sound.
    video?.play()?.catch(() => {});
  }

  showError() {
    const error = this.querySelector('[data-installation-error]');
    if (error) error.hidden = false;
  }

  finishClose() {
    this.querySelector('video')?.pause();
    this.trigger?.setAttribute('aria-expanded', 'false');
    if (this.ownsScrollLock) document.documentElement.classList.remove('mochi-installation-open');
    this.ownsScrollLock = false;
    if (this.isConnected) this.trigger?.focus({ preventScroll: true });
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.abortController = null;
    if (this.dialog?.open) this.dialog.close();
    this.finishClose();
  }
}

if (!customElements.get('mochi-installation-video')) {
  customElements.define('mochi-installation-video', MochiInstallationVideo);
}
